// Shared helpers for the read-only register viewer (uncertainty + coverage).

export const COUNTRY_LABEL = {
  MT: "Malta", GI: "Gibraltar", CY: "Cyprus", AG: "Antigua & Barbuda", CA: "Canada",
  CW: "Curaçao", IM: "Isle of Man", SE: "Sweden", RO: "Romania", CR: "Costa Rica",
  GB: "United Kingdom", UK: "United Kingdom", EE: "Estonia", ES: "Spain", PT: "Portugal",
  IE: "Ireland", DE: "Germany", MX: "Mexico", PH: "Philippines", US: "United States",
};
export const countryLabel = (c) => COUNTRY_LABEL[c] || c;

export const cap = (s) => (s ? s.charAt(0).toUpperCase() + s.slice(1) : s);
export const uniq = (a) => Array.from(new Set(a));

export const REMOTE_LABEL = {
  remote: "Remote", hybrid: "Hybrid", onsite: "Onsite", unknown: "Remote policy unknown",
};

export function domainBasis(basis) {
  switch (basis) {
    case "authorised":
      return { label: "Regulator-approved domains", note: "The regulator approved these domains." };
    case "notified":
      return { label: "Operator-notified domains", note: "The operator notified these domains to the regulator." };
    case "self-declared":
      return { label: "Self-declared domains", note: "Taken from the company's own site, not confirmed with a regulator." };
    default:
      return { label: "Domains", note: "" };
  }
}

const DAY = 86400000;

export function ageLabel(dateStr) {
  if (!dateStr) return null;
  const days = Math.floor((Date.now() - new Date(dateStr).getTime()) / DAY);
  if (days < 1) return "today";
  if (days === 1) return "1 day ago";
  if (days < 30) return `${days} days ago`;
  if (days < 365) return `${Math.floor(days / 30)} months ago`;
  const y = Math.floor(days / 365);
  return y <= 1 ? "over a year ago" : `over ${y} years ago`;
}

export const isStale = (dateStr) =>
  dateStr ? Date.now() - new Date(dateStr).getTime() > 180 * DAY : false;

// Licence status styling. Suspended / Revoked must read as alarming at a glance.
export function statusStyle(status) {
  if (status === "Suspended")
    return { label: "Suspended", cls: "border-amber-500/50 bg-amber-500/10 text-amber-700", alarm: true };
  if (status === "Revoked")
    return { label: "Revoked", cls: "border-red-500/50 bg-red-500/10 text-red-700", alarm: true };
  if (!status)
    return { label: "Status not published", cls: "border-[#DDDAD1] bg-transparent text-slate-500", alarm: false };
  return { label: status, cls: "border-teal-400/30 bg-teal-500/5 text-teal-600", alarm: false };
}

// Coverage state for a jurisdiction. "never" = not in coverage (absence of
// knowledge). "partial" / "full" come from the sweep entry.
export function coverageState(jurisdiction, coverage) {
  if (!coverage || !jurisdiction) return { state: "unknown" };
  const inScope = (coverage.jurisdictions_in_scope || []).includes(jurisdiction);
  const entry = (coverage.entries || {})[jurisdiction];
  if (!entry) return { state: "never", inScope };
  return { state: entry.sweep_type === "partial" ? "partial" : "full", entry };
}

export const fmtDate = (d) => (d ? new Date(d).toLocaleDateString("en-GB") : "");
